// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__4LdJY","mainContent":"Layout_mainContent__ooasp"};